import React from 'react';
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import axios from 'axios';
import { Popup } from '../../../Utils/Alert';
import { MunicipalityNaneFrontSetting, nodeURL } from '../../../config';

export default function KodSorgulama() {

    const MySwal = withReactContent(Swal)

    const checkToken = () => {

        let dogrulamaKodu = document.getElementById('dogrulanacakKod').value
        console.log(dogrulamaKodu)
        if (dogrulamaKodu.length < 3) {
            alert('Lütfen doğrulama kodunu tam olarak giriniz.')
            return
        }

        axios.get(`${MunicipalityNaneFrontSetting.nodeURL}pdfSorgu/get/adres/kod/sorgula/${dogrulamaKodu}`, { responseType: 'blob' })
            .then((res) => {
                console.log(res, "data react")
                const blobContent = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                Popup(<iframe style={{ height: '70vh', width: '100%' }} src={blobContent}></iframe>, { width: '950px' })
            }).catch((err) => { })

        // MySwal.fire({
        //     width: '90%',
        //     showConfirmButton: false,
        //     showCancelButton: false,
        //     html: <iframe title={'Adres Tespit Belgesi'} src={`https://adres.trabzon.bel.tr/nomaksapi/public/AdresKodSorgulama/${dogrulamaKodu}`} width="100%" height="700px"></iframe>

        // })
    }

    return <div className="row">
        <div className="col-3" style={{ marginLeft: '10px', marginTop: '5px' }}>
            Kod
        </div>
        <div className="col-8">
            <input id='dogrulanacakKod' type='text' className='form-control form-control-sm' ></input>
        </div>
        <div className="col-12 d-flex justify-content-end">
            <button className='btn btn-warning btn-sm' style={{ margin: '10px' }} onClick={() => checkToken()} id='adresTespitBtn'>Kontrol Et</button>
        </div>
    </div>;
}
